const noratedisclaimer_reducer = (state = "", action) => {
	switch(action.type) {

		case 'UPDATENORATEDISCLAIMER':
			return action.payload;

		default:
			return state;
	}
}

export default noratedisclaimer_reducer;